import React from 'react';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';

import Style from './resaleTicketCard.module.css';
import { Card, HeaderCard, TitleCard, ContentCard, Numbers, TooltipHelp, CopyToClipboardLink, Tooltip, Icon } from '@weezevent/nacre';

function ResaleTicketRow({ title, value }) {
    return (
        <div className={`${Style['resaleticket-row']}`}>
            <div className={`${Style['title']}`}>{title}</div>
            <div className={`${Style['value']}`}>{value}</div>
        </div>
    );
}

function LinkToAttendee({ value, url }) {
    const { t } = useTranslation();
    return (
        <div className={Style['resaleticket-LinkToAttendee'] + ' wz-link-with-actions'}>
            <Tooltip title={t('ticket.moderation.attendees.table.actionSeeAttendee')} triggerOnHover mouseEnterDelay={0} mouseLeaveDelay={0}>
                <a className="wz-link" href={url} target="_blank" rel="noopener noreferrer">
                    <span className="text">{value}</span>
                    <span className="external-icon">
                        <Icon name="external-link" />
                    </span>
                </a>
            </Tooltip>
            <CopyToClipboardLink value={value} tooltipCopied={t('ticket.common.copied')} tooltip={t('ticket.common.copy-barcode')} />
        </div>
    );
}

export function ResaleTicketCard({ resoldTo, resoldFrom, currency, prefix }) {
    const locale = i18n.language;
    const { t } = useTranslation();
    const tradKey = 'ticket.manager.attendees.detail.resaleInformation';

    const formattedDate = React.useMemo(() => {
        if (!resoldTo) return '-';

        return new Intl.DateTimeFormat(locale, {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: false
        }).format(new Date(resoldTo.created));
    }, [locale, resoldTo]);

    return (
        <Card>
            <HeaderCard>
                <TitleCard title={t(`${tradKey}.cardTitle`)} />
            </HeaderCard>
            <ContentCard>
                <ResaleTicketRow title={t(`${tradKey}.resaleStatus.title`)} value={resoldTo ? t(`${tradKey}.resaleStatus.${resoldTo.status}`) : '-'} />
                <ResaleTicketRow title={t(`${tradKey}.resaleDate`)} value={resoldTo ? formattedDate : '-'} />
                <ResaleTicketRow
                    title={
                        <div>
                            {t(`${tradKey}.resalePrice`)}
                            <TooltipHelp title={t(`${tradKey}.priceTooltip`)} />
                        </div>
                    }
                    value={resoldTo ? <Numbers value={resoldTo.price} currency={currency} showNullDecimal locale={locale} /> : '-'}
                />
                <ResaleTicketRow title={t(`${tradKey}.resalePrivate`)} value={resoldTo ? (resoldTo.private ? t('ticket.common.yes') : t('ticket.common.no')) : '-'} />
                <ResaleTicketRow
                    title={t(`${tradKey}.newTicket`)}
                    value={
                        resoldTo && resoldTo.barcode_new_attendee ? (
                            <LinkToAttendee value={resoldTo.barcode_new_attendee} url={`${prefix}/attendees/${resoldTo.new_attendee_id}`} />
                        ) : (
                            '-'
                        )
                    }
                />
                <ResaleTicketRow
                    title={t(`${tradKey}.formerTicket`)}
                    value={resoldFrom ? <LinkToAttendee value={resoldFrom.barcode_attendee_resold} url={`${prefix}/attendees/${resoldFrom.attendee_resold_id}`} /> : '-'}
                />
            </ContentCard>
        </Card>
    );
}
